// extracted by mini-css-extract-plugin
export default {"formContainer":"rut-form_formContainer__zK44+"};